import Nav from 'react-bootstrap/Nav';
import { useState } from 'react';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import { useRef } from 'react';
import '../../App.css';
import '../../css/bootstrap.scss';
import user_icon from "../../images/reg_user.png";
import { Link } from 'react-router-dom';
import Header from '../Includes/Header';
import Footer from '../Includes/Footer';
import { useNavigate } from 'react-router-dom';
import BackButton from '../Includes/BackButton';
import { useTranslation } from 'react-i18next';

function SecureIdentityVerificationMethods() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [validated, setValidated] = useState(false);
    const [activeNavItem, setActiveNavItem] = useState('Send Email');

    const handleNavItemClick = (item: any) => {
        setActiveNavItem(item);
    };

    const [showPassword, setShowPassword] = useState(false);

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };

    return (
        <>
            <Header />
            <Container fluid className='min-vh-custom bg-sky'>
                <Row>
                    <Col md={12}>
                        <div className='mt-5'>
                            <Col md={3} className='text-center py-4'>
                                <Row className='justify-content-center'>
                                    <BackButton />
                                </Row>
                            </Col>

                            <Col md={12} className='text-center justify-content-center'>
                                <img src={user_icon} width={50} />
                                <h3 className='text-center mt-3 mb-2'>{t('login.secure_title')}</h3>
                                <p className='text-secondary mb-4 letter-spacing-fix'>{t('login.verify_links_mobile')}</p>

                                <Row className='justify-content-center'>
                                    <Col md={4} className='bg-white rounded-3' style={{ width: '525px' }}>
                                        <Form noValidate validated={validated}>
                                            <Row>
                                                <label className="form-label fw-bold py-3 letter-spacing-fix">{t('login.continue_verification')}</label>
                                                <Nav className='nav-fill' variant="underline" defaultActiveKey="/home">
                                                    <Nav.Item>
                                                        <Nav.Link
                                                            eventKey="send_email"
                                                            className={`py-3 px-3 ${activeNavItem === 'Send Email' ? 'active' : 'text-black'}`}
                                                            onClick={() => handleNavItemClick('Send Email')}
                                                        >
                                                            {t('login.send_email_link')}
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link
                                                            eventKey="scan_QR_Code"
                                                            className={`py-3 px-3 ${activeNavItem === 'Scan QR Code' ? 'active' : 'text-black'}`}
                                                            onClick={() => handleNavItemClick('Scan QR Code')}
                                                        >
                                                            {t('login.scan_qr_link')}
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link
                                                            eventKey="copy_link"
                                                            className={`py-3 px-3 ${activeNavItem === 'Copy Link' ? 'active' : 'text-black'}`}
                                                            onClick={() => handleNavItemClick('Copy Link')}
                                                        >
                                                            {t('login.copy_link')}
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                </Nav>
                                            </Row>

                                            <Row className={activeNavItem === 'Send Email' ? '' : 'd-none'} id="send_email_div">
                                                <Form noValidate validated={validated} className=''>
                                                    <p className="mt-4 fw-bold m-0">{t('login.receive_link')}</p>
                                                    <p className='text-secondary small mt-1'>{t('login.enter_email_link_desc')}</p>
                                                    <Row className='px-2'>
                                                        <label className="form-label text-start">{t('login.email_phone')}</label>
                                                        <input type="text" className="form-control rounded-5 py-3 mt-2" placeholder='youremail@email.com' />
                                                        <p className='text-secondary small mt-3 text-start'>{t('login.spam_note')}</p>
                                                    </Row>
                                                    <Row className=''>
                                                        <Col md={12} className='py-2'>
                                                            <Button className="btn rounded-5 border-0 text-white w-75" style={{ background: '#0B1628' }} onClick={() => { navigate('/') }}>{t('login.send_link_btn')}</Button>
                                                        </Col>
                                                    </Row>
                                                </Form>
                                            </Row>

                                            <Row className={activeNavItem === 'Scan QR Code' ? '' : 'd-none'} id="scan_QR_code_div">
                                                <Col>
                                                    <Form noValidate validated={validated} className=''>
                                                        <p className="mt-4 fw-bold m-0">{t('login.scan_qr_link')}</p>
                                                        <p className='text-secondary small mt-1'>{t('login.scan_qr_desc2')}</p>
                                                        <Row className='justify-content-center text-center'>
                                                            <Col md={12} className='py-2 text-center'>
                                                                <Button className="btn rounded-5 border-0 text-white w-75" style={{ background: '#0B1628' }} onClick={() => { navigate('/') }}>{t('login.generate_code')}</Button>
                                                            </Col>
                                                        </Row>
                                                    </Form>
                                                </Col>
                                            </Row>

                                            <Row className={activeNavItem === 'Copy Link' ? '' : 'd-none'} id="copy_link_div">
                                                <Col>
                                                    <Form noValidate validated={validated} className=''>
                                                        <p className="mt-4 fw-bold m-0">{t('login.copy_link')}</p>
                                                        <p className='text-secondary small mt-1'>{t('login.copy_link_desc')}</p>
                                                        <Row className='justify-content-center mb-3'>
                                                            <Col md={12} className='py-2'>
                                                                <Button className="btn rounded-5 border-0 text-white w-75" style={{ background: '#0B1628' }} onClick={() => { navigate('/') }}>{t('login.generate_link')}</Button>
                                                            </Col>
                                                        </Row>
                                                    </Form>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Col>
                                </Row>
                            </Col>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Footer full={true} />
        </>
    );
}

export default SecureIdentityVerificationMethods;
